import { actions as generalUiActions } from '@ff-scene-plugins/photo-prints-redux/slices/generalUiSlice';
import { actions as groupsActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { actions as photosActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpThunk } from '@ff-scene-plugins/photo-prints-redux/store';
import { isMagicEffect } from '@ff-scene-plugins/photo-prints-shared/effectUtils';
import { magic_effects } from '@ff-scene-plugins/photo-prints-shared/magic_effects';
import { standard_effects } from '@ff-scene-plugins/photo-prints-shared/standard_effects';

const getAssetIdFromEffectId = (effectId: string): string | undefined => {
    const allEffects = [...magic_effects, ...standard_effects];
    const effect = allEffects.find(e => e.id === effectId);
    return effect?.assetId || undefined;
};

export const applyMagicBorderThunk = (
    groupId: string,
    effectId: string | null
): PhotoPrintsPdpThunk => {

    const { updateItem, updateMagicBorderForGroup, removeMagicBorderForGroup } = generalUiActions;

    return async (dispatch: PhotoPrintsPdpDispatch) => {

        const APPLYING_BORDER_PROCESSING_ANIMATION_DURATION = 200;

        try {

            dispatch(updateItem({
                key: 'isPhotoFunProcessing',
                value: true
            }));
            if (!effectId) {
                dispatch(groupsActions.removeBorder(groupId));
                dispatch(photosActions.removeBorder({groupId}));
                dispatch(removeMagicBorderForGroup(groupId));
            } else {
                if (isMagicEffect(effectId)) {
                    dispatch(groupsActions.setMagicBorder({
                        groupId,
                        magicBorderId: effectId,
                        magicBorderAssetId: getAssetIdFromEffectId(effectId)
                    }));

                    dispatch(photosActions.applyMagicBorder({
                        groupId,
                        magicBorderId: effectId
                    }));

                    dispatch(updateMagicBorderForGroup({
                        groupId,
                        magicBorderId: effectId
                    }));
                } else {
                    dispatch(groupsActions.setPattern({
                        groupId,
                        patternId: effectId
                    }));

                    dispatch(photosActions.applyPattern({
                        groupId,
                        patternId: effectId
                    }));

                    dispatch(updateMagicBorderForGroup({
                        groupId,
                        magicBorderId: effectId // Keep this for UI state consistency
                    }));
                }
            }

            await new Promise(resolve => setTimeout(resolve, APPLYING_BORDER_PROCESSING_ANIMATION_DURATION));

            dispatch(updateItem({
                key: 'isPhotoFunProcessing',
                value: false
            }));

        } catch (error) {

            dispatch(updateItem({
                key: 'isPhotoFunProcessing',
                value: false
            }));

            console.error('Error in applyMagicBorderThunk:', error);
        }
    };
};